import { verifiedSupplierChoices } from "./supplierSelection";

export function agreementRegisterState(agreement) {
  if (["proposed", "pending"].includes(agreement.status))
    return agreement.invitationDelivery === "sent" ? "awaiting" : "proposed";
  if (["ended", "rejected"].includes(agreement.status))
    return !agreement.supplierSignedAt &&
      agreement.events?.some((event) => event.action === "expired")
      ? "expired"
      : "ended";
  return agreement.status;
}
export const agreementRegisterLabel = (state) =>
  ({
    active: "Active",
    proposed: "Proposed",
    awaiting: "Awaiting signature",
    suspended: "Suspended",
    ended: "Ended",
    expired: "Expired",
  }[state] || state);
export function agreementMatchesGroup(agreement, group) {
  const state = agreementRegisterState(agreement);
  if (group === "all") return true;
  if (group === "progress") return ["proposed", "awaiting"].includes(state);
  if (group === "unavailable")
    return ["suspended", "ended", "expired"].includes(state);
  return state === group;
}
export function agreementRegisterSummary(agreements) {
  return {
    active: agreements.filter((a) => agreementMatchesGroup(a, "active")).length,
    progress: agreements.filter((a) => agreementMatchesGroup(a, "progress"))
      .length,
    unavailable: agreements.filter((a) =>
      agreementMatchesGroup(a, "unavailable")
    ).length,
  };
}

// Creation choices exclude contacts already covered by an active agreement.
export function availableAgreementContacts(contacts = [], agreements = []) {
  const active = new Set(
    agreements
      .filter((a) => a.status === "active")
      .map((a) => String(a.contactID?._id || a.contactID || ""))
  );
  return verifiedSupplierChoices(contacts).filter(
    (contact) =>
      contact.hasActiveRctiAgreement !== true &&
      !active.has(String(contact._id))
  );
}
